<template>
  <div class="slide-group">
    <div class="group">
      <LocalizedInput title="TITLE" :translate="value.title"/>
    </div>
    <div class="group">
      <LocalizedInput :title="$t('description')" :translate="value.description"/>
    </div>
    <div class="columns">
      <div class="column">
        <!-- SLIDES -->
        <div class="group">
          <label>SLIDES</label>
          <AjaxSelect
            v-model="newSlide"
            api="/api/entity/slide/select"
            placeholder="Add slide"
            :allow-empty-search="true"
            :map-fn="(s) => $to(s.title)"
            :ignored="alreadyIncludedSlideIds"
            style="margin-bottom: 20px"
          />
          <Draggable v-model="value.slides" handle=".handle">
            <div v-for="(s,i) of value.slides" :key="`sg_sl_${s.id}`" class="mtm-row">
              <div class="label-group">
                <div class="handle">≡</div>
                <div>{{$to(s.title)}}</div>
              </div>
              <button class="btn btn-primary" @click="removeSlide(i)">-</button>
            </div>
          </Draggable>
        </div>
      </div>

      <div class="column">
        <!-- BRANCHES -->
        <div class="group">
          <label>BRANCHES</label>
          <AjaxSelect
            v-model="newBranch"
            api="/api/entity/branch/select"
            placeholder="Link to branch"
            :allow-empty-search="true"
            :map-fn="(s) => s.name"
            :ignored="alreadyIncludedBranchIds"
            style="margin-bottom: 20px"
          />

          <div v-for="(b,i) of value.branches" :key="`sg_br_${b.id}`" class="mtm-row">
            <div>{{b.name}}</div>
            <button class="btn btn-primary" @click="removeBranch(i)">-</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Draggable from 'vuedraggable';
import LocalizedInput from "@/components/tools/LocalizedInput";
import AjaxSelect from "@/components/tools/AjaxSelect";

export default {
  name: "SlideGroup",
  components: {LocalizedInput, AjaxSelect, Draggable},

  props: {
    value: Object,
  },

  data() {
    return {
      newSlide: {id: null},
      newBranch: {id: null}
    }
  },

  computed: {
    alreadyIncludedSlideIds() {
      return this.value.slides.map(s => s.id);
    },
    alreadyIncludedBranchIds() {
      return this.value.branches.map(b => b.id);
    }
  },

  watch: {
    "newSlide.id"(id) {
      if (id) {
        this.value.slides.push( Object.assign({priority: null}, this.newSlide) );
        this.newSlide = {id: null};
      }
    },
    "newBranch.id"(id) {
      if (id) {
        this.value.branches.push( Object.assign({priority: null}, this.newBranch) );
        this.newBranch = {id: null};
      }
    }
  },

  methods: {
    removeSlide(index) {
      this.value.slides.splice(index, 1);
    },
    removeBranch(index) {
      this.value.branches.splice(index, 1);
    }
  }
}
</script>

<style lang="scss" scoped>
.mtm-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;

  .label-group {
    display: flex;
  }
  .handle {
    margin-right: 5px;
  }
}
</style>